<template>
    <a-modal
        title="重置密码"
        :width="500"
        :visible="visible"
        :confirmLoading="loading"
        :maskClosable="false"
        @ok="$emit('ok')"
        @cancel="$emit('cancel')"
    >
        <a-form-model ref="passwordForm" :model="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 15 }">
            <a-form-model-item
                label="新密码"
                prop="password"
                :rules="[{ required: true, message: '请输入新密码', trigger: 'blur' }]"
            >
                <a-input v-model="form.password" />
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>

<script>
export default {
    props: {
        id: {
            type: Number,
            required: true
        },
        visible: {
            type: Boolean,
            required: true
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            form: {
                id: 0,
                password: ''
            }
        };
    },
    watch: {
        id: {
            immediate: true,
            handler(val) {
                this.form.id = val || 0;
            }
        },
        visible(val) {
            if (val) {
                this.form.password = '';
                this.$nextTick(() => {
                    if (this.$refs.passwordForm) {
                        this.$refs.passwordForm.clearValidate();
                    }
                });
            }
        }
    }
};
</script>
